import { Link } from "react-router-dom";
import { formatDate, formatViews } from "@/lib/articles";
import type { Article } from "@/mocks/articles";

interface RecommendCardProps {
  article: Article;
}

export default function RecommendCard({ article }: RecommendCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
      <Link
        to={`/detail/${article.id}`}
        className="relative aspect-[2/3] w-full overflow-hidden bg-background-100"
        aria-label={article.title}
      >
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 蜜桃33`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-star-fill text-accent-400" />
          {formatViews(article.views)} 热度
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex flex-wrap gap-1.5">
          {article.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="mt-2 text-base font-semibold text-foreground-950">
          <Link to={`/detail/${article.id}`} className="link-underline">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {article.summary}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{formatDate(article.publishedAt)}</span>
          <Link
            to={`/detail/${article.id}`}
            className="flex items-center gap-1 font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看详情
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>
      </div>
    </article>
  );
}